export default __webpack_public_path__ + "static/media/homeSweet.6622485b.png";